import { constantToDisplayName } from "../../../core/constantToDisplayName";
import { useField } from 'formik';
import { useEffect } from 'react';
import { FormGroup, RadioGroup } from 'tombac';
import { ContractAccessType } from "../../contractTypes";
import { jsx as _jsx } from "react/jsx-runtime";
const accessTypeOptions = [ContractAccessType.Paid, ContractAccessType.Demo, ContractAccessType.Custom].map(at => ({
  label: constantToDisplayName(at),
  value: at
}));
export const ContractAccessTypeField = ({
  name,
  ...stylingProps
}) => {
  const [field,, helpers] = useField(name);
  const value = accessTypeOptions.find(o => o.value === field.value) ?? null;
  useEffect(function preventEmptyValue() {
    if (!value) {
      helpers.setValue(ContractAccessType.Paid);
    }
  }, [value]);
  return /*#__PURE__*/_jsx(FormGroup, {
    label: "Access",
    htmlFor: "field-access-type",
    ...stylingProps,
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "ContractAccessTypeField",
    "data-sentry-source-file": "ContractAccessTypeField.tsx",
    children: /*#__PURE__*/_jsx(RadioGroup, {
      ...field,
      id: "field-access-type",
      onChange: option => helpers.setValue(option.value),
      options: accessTypeOptions,
      variant: "horizontal",
      value: value,
      "data-sentry-element": "RadioGroup",
      "data-sentry-source-file": "ContractAccessTypeField.tsx",
      "data-sentry-element": "RadioGroup"
    })
  });
};